module.exports = __webpack_public_path__ + "static/media/k5-promo-glossy.ba9ca599.png";